import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Box, Typography, Avatar, Chip, Tooltip } from '@mui/material';
import { 
  Person as PersonIcon, 
  CheckCircle as CheckCircleIcon,
  Warning as WarningIcon,
  Cancel as CancelIcon,
  Group as GroupIcon 
} from '@mui/icons-material';
import { IndicacaoNodeData, getCoresNivel, formatarNomeNode } from '../../../utils/indicacaoFlowUtils';

const IndicacaoClienteNode: React.FC<NodeProps<IndicacaoNodeData>> = ({ data }) => {
  const cores = getCoresNivel(data.nivel);
  const nomeFormatado = formatarNomeNode(data.nome, 16);

  // Função para obter ícone do status
  const getStatusIcon = () => {
    switch (data.status) {
      case 'ativo':
        return <CheckCircleIcon sx={{ fontSize: 14, color: '#4caf50' }} />;
      case 'suspenso':
        return <WarningIcon sx={{ fontSize: 14, color: '#ff9800' }} />;
      case 'inadimplente':
        return <CancelIcon sx={{ fontSize: 14, color: '#f44336' }} />;
      default:
        return <PersonIcon sx={{ fontSize: 14 }} />;
    }
  };

  // Função para obter cor do status
  const getStatusColor = () => {
    switch (data.status) {
      case 'ativo':
        return '#4caf50';
      case 'suspenso':
        return '#ff9800';
      case 'inadimplente':
        return '#f44336';
      default:
        return '#9e9e9e';
    }
  };
  
  const getNivelImagem = () => {
    switch (data.nivel) {
      case 1:
        return '/nivel1.png';
      case 2:
        return '/nivel2.png';
      case 3:
        return '/nivel3.png';
      default:
        return '/nivel0.png';
    }
  };

  // Função para formatar data
  const formatarData = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  return (
    <Box
      sx={{
        width: 50,
        height: 20,
        background: 'white',
        border: `2px solid ${cores.border}`,
        borderRadius: '100%',
        padding: '10px 5px',
        boxShadow: '0 3px 10px rgba(0,0,0,0.12)',
        position: 'relative',
        color: cores.text,
      }}
    >
      

      {/* Avatar do cliente */}
      <Box sx={{ display: 'flex',
        alignItems: 'center',
        
         justifyContent: 'center',
         marginTop: '-75px',

         position: 'relative',
        }}>
        <img src={getNivelImagem()} width={80} height={80} alt="SysUp" />
      </Box>
      <Chip label={data.nome} sx={{
        marginTop: '5px',
        minWidth: "120px",
        maxWidth: '120px',
        width: 'auto',
        height: '17px',
        marginLeft: '-43px',
        backgroundColor: 'white',
        border: `1px solid ${cores.border}`,
        color: 'black',
        
        borderRadius: '10px',
        '& .MuiChip-label': {
          textOverflow: 'ellipsis',
          textAlign: 'center',
          fontSize: '10px',
        }
      }}
      />
      {/* Handle de entrada */}
      <Handle
        type="target"
        position={Position.Top}
        style={{
          width: 5,
          height: 5,
          border: 'none',
          background: 'transparent',
        }}
      />

      {/* Handle de saída (se tem indicações) */}
      {data.totalIndicados > 0 && (
        <Handle
          type="source"
          position={Position.Bottom}
          style={{
            width: 5,
            height: 5,
            border: 'none',
            background: 'transparent',
          }}
        />
      )}
    </Box>
  );
};

export default IndicacaoClienteNode; 